import r from 'reactotron-react-js'

export const mappingBudgetTypeAndGL = ({itemValueForm, glAccounts, budgetTypeOptions, companyCode, costCenter, currentGl}) => {
  const defaultBudgetType = budgetTypeOptions.length === 1 ? budgetTypeOptions[0].value : ''
  if (!itemValueForm.initial) {
    if (!itemValueForm.budgetType) {
      itemValueForm.budgetType = defaultBudgetType
    }

    if (itemValueForm.budgetType) {
      const listGl = glAccounts.filter(gl => gl.budgetTypeCode === itemValueForm.budgetType)
      if (listGl) {
        if (listGl.length === 1) {
          const gl = listGl[0]
          itemValueForm.accountAssignment = gl.accountAssignment
          itemValueForm.glAccountCode = currentGl || gl.glAccount || ''
        } else {
          const uniqueAccountAssignment = []
          listGl.forEach(gl => {
            if (uniqueAccountAssignment.indexOf(gl.accountAssignment) === -1) {
              uniqueAccountAssignment.push(gl.accountAssignment)
            }
          })
  
          if (uniqueAccountAssignment.length === 1) {
            itemValueForm.accountAssignment = uniqueAccountAssignment[0]
  
            const glByAccountAssignment = listGl.filter(gl => gl.accountAssignment === itemValueForm.accountAssignment) 
            if (glByAccountAssignment) {
              if (glByAccountAssignment.length === 1) {
                itemValueForm.glAccountCode = currentGl || glByAccountAssignment[0].glAccount || ''
              } else {
                const glByCompany = glByAccountAssignment.find(gl => gl.companyCode === companyCode)
                if (glByCompany) {
                  itemValueForm.glAccountCode = currentGl || glByCompany.glAccount || ''
                  
                  if (costCenter) {
                    if (glByCompany.ignoreByCostCenters.find(c => {
                      if (c.includes('*')) {
                        return costCenter.include(c.replace('*', ''))
                      }

                      if (c.includes('-')) {
                        const listCostCenter = c.split('-') || []
                        if (listCostCenter.length > 1) {
                          let c1 = Number.parseInt(listCostCenter[0])
                          let c2 = Number.parseInt(listCostCenter[1])
                          let cc = Number.parseInt(costCenter)
                          if (c1 && c2 && cc) {
                            return (cc >= c1 && cc <= c2)
                          }
                        }
                      }
  
                      return c === costCenter
                    })) {
                      itemValueForm.glAccountCode = currentGl || glByCompany.glAccountForIgnore || ''
                    } 
                  }
                } else {
                  const gl = glByAccountAssignment.find(gl => gl.companyCode === 'ALL')
                  itemValueForm.glAccountCode = currentGl || gl ? gl.glAccount ? gl.glAccount : '' : ''
                }
              }
            }
          }
        }
      }
    } else {
      itemValueForm.accountAssignment = ''
      itemValueForm.glAccountCode = currentGl || ''
    }

    itemValueForm.initial = true
  }

  return itemValueForm
}

export const filterWbs = (props) => {
  const { itemValueForm, glAccounts, budgetTypeOptions, wbsElements } = props

  var wbsOptions = []
  if (itemValueForm.budgetType && itemValueForm.accountAssignment) {
    const listGl = glAccounts.filter(gl => (
      gl.budgetTypeCode === itemValueForm.budgetType &&
      gl.accountAssignment === itemValueForm.accountAssignment))

    if (listGl) {
      if (listGl.length === 1) {
        const glAccount = listGl[0]
        if (glAccount.wbsPrefixs) {
          //TO DO :: filter by prefix
          glAccount.wbsPrefixs.forEach(prefix => {
            wbsElements.forEach(wbs => {
              if (wbs.value.indexOf(prefix) === 0 && 
                  wbs.wbsStatus.indexOf('CLSD') === -1 &&
                  wbs.wbsStatus.indexOf('TECO') === -1) {
                wbsOptions.push(wbs)
              }
            })
          })
          // wbsOptions = wbsElements.filter(w => w.value.indexOf())
        } else {
          wbsOptions = wbsElements
        }
      }
    }
  }

  return wbsOptions
}

export const generateBudgetTypeOption = (budgetTypeOptions, listBudgetTypeBySubCat) => {
  var budgetTypes = budgetTypeOptions.map(b => ({
    value: b.value,
    text: b.text,
    disabled: listBudgetTypeBySubCat ? listBudgetTypeBySubCat.find(bt => bt === b.value) ? false : true : false
  }))
  budgetTypes = budgetTypes.sort((a, b) => (a.disabled === b.disabled)? 0 : !a.disabled? -1 : 1)
  const enableBudgetType = budgetTypes.filter(b => b.disabled === false)
  return enableBudgetType
}

export const generateAccountAssignmentOption = (accountAssignmentOption, budgetType, glAccounts) => {
  if (budgetType) {
    var uniqueAccountAssignment = []
    var listByBudgetType = glAccounts.filter(g => g.budgetTypeCode === budgetType)
    if (listByBudgetType) {
      if (listByBudgetType.length === 1) {
        uniqueAccountAssignment.push(listByBudgetType[0].accountAssignment)
      } else {
        listByBudgetType.forEach(gl => {
          if (uniqueAccountAssignment.indexOf(gl.accountAssignment) === -1) {
            uniqueAccountAssignment.push(gl.accountAssignment)
          }
        })
      }

      var listAvailableAccAssign = accountAssignmentOption.filter(aa => uniqueAccountAssignment.indexOf(aa.value) !== -1)
      var accountAssignments = listAvailableAccAssign.map(aa => ({
        value: aa.value,
        text: aa.text,
      }))
      return accountAssignments
    } else {
      return []
    }
  } else {
    return []
  }
}